import { HttpParams } from "@angular/common/http";

import { ManagerListFilters } from "../models/core/manager.interface";
import { Pagination } from "../models/pagination.interface";

/**
 * Monta a query string da listagem de gestores (DEV-916, CA 03 e CA 07). Vive num util, e não em
 * cada service, porque os dois níveis — `NetworkService` e `SchoolService` — mandam EXATAMENTE os
 * mesmos parâmetros: o backend serve os três níveis com o mesmo contrato de request.
 *
 * `pageNumber` e não `page`: é o alias que o admin usa em todas as listagens e que os dois requests
 * do backend declaram.
 *
 * Parâmetro vazio é OMITIDO em vez de ir em branco. Mandar `sorts=` faria o backend cair no ramo
 * padrão — inofensivo —, mas mandar `txSearch=` vazio entraria no `IsNullOrWhiteSpace` e também
 * seria ignorado; omitir deixa a requisição legível no DevTools e no log.
 */
export function buildManagerListParams(
  pagination: Pagination,
  filters: ManagerListFilters = {}
): HttpParams {
  let params = new HttpParams()
    .set("pageNumber", pagination.pageNumber.toString())
    .set("pageSize", pagination.pageSize.toString());

  const search = filters.search?.trim();
  if (search) {
    params = params.set("txSearch", search);
  }

  if (filters.sorts) {
    params = params.set("sorts", filters.sorts);
  }

  // Repetido, não separado por vírgula: é como o repositório já manda lista de id
  // (`school.service.ts:49-55`, `idNetwork`/`idSubNetwork`).
  filters.idStages?.forEach((idStage) => (params = params.append("idStages", idStage)));

  return params;
}
